import { apiFetch } from './apiClient.js';

export interface Tenant {
  id: string;
  slug: string;
  name: string;
  tier: 'logical' | 'physical';
  status?: 'active' | 'suspended' | 'pending';
  defaultLocale?: string;
  /** #152 — IANA timezone para reportes/dashboards. Default America/Bogota. */
  appTimeZone?: string;
  featureFlags?: Record<string, boolean>;
  version?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface ListTenantsResult {
  items: Tenant[];
  nextToken?: string;
}

export async function listTenants(opts: { limit?: number; nextToken?: string; status?: Tenant['status'] } = {}): Promise<ListTenantsResult> {
  const qs = new URLSearchParams();
  if (opts.limit) qs.set('limit', String(opts.limit));
  if (opts.nextToken) qs.set('nextToken', opts.nextToken);
  if (opts.status) qs.set('status', opts.status);
  const suffix = qs.toString() ? `?${qs}` : '';
  return apiFetch<ListTenantsResult>(`/v1/tenants${suffix}`);
}

export async function getTenant(id: string): Promise<Tenant> {
  return apiFetch<Tenant>(`/v1/tenants/${encodeURIComponent(id)}`);
}

export async function createTenant(input: Omit<Tenant, 'id' | 'createdAt' | 'updatedAt' | 'version'>): Promise<Tenant> {
  return apiFetch<Tenant>('/v1/tenants', { method: 'POST', body: input });
}

export type TenantPatch = Partial<
  Pick<Tenant, 'name' | 'tier' | 'status' | 'defaultLocale' | 'appTimeZone' | 'featureFlags'>
>;

export async function updateTenant(id: string, patch: TenantPatch, ifMatchVersion: number): Promise<Tenant> {
  return apiFetch<Tenant>(`/v1/tenants/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: patch,
    headers: { 'If-Match': String(ifMatchVersion) },
  });
}
